import { useRef, useState } from "react";
import ColorBox from "./ColorBox";
import { Box } from "../../../Box";
import { palette } from "../../../../../styles/theme";
import ColorPicker from "../../ColorPicker/ColorPicker";
import { Icon } from "../../../Icon";

interface Props {
  value: string;
  onChange: (color: string) => void;
  anchorEl?: HTMLElement | null;
}

const ColorBoxPicker = ({ value, onChange, anchorEl }: Props) => {
  const [isPickerOpen, setIsPickerOpen] = useState(false);
  const anchorElRef = useRef<HTMLDivElement>(null);

  return (
    <>
      <Box ref={anchorElRef}>
        {value ? (
          <ColorBox
            colorOrCombo={value}
            isActive={false}
            disabled={false}
            onClick={() => {
              setIsPickerOpen(true);
            }}
            tooltip={""}
          />
        ) : (
          <Box
            sx={{
              width: "22px",
              height: "22px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "4px",
              border: `1px solid ${palette.grey.darkGrey}`,
              cursor: "pointer",
              "&:hover": {
                borderColor: palette.grey.darkerGrey,
                "& span": {
                  color: `${palette.grey.darkerGrey} !important`,
                },
              },
            }}
            onClick={() => {
              setIsPickerOpen(true);
            }}
          >
            <Icon icon="add" size={18} color={palette.grey.darkGrey} />
          </Box>
        )}
      </Box>
      <ColorPicker
        value={value}
        isOpen={isPickerOpen}
        onColorChange={onChange}
        onClose={() => setIsPickerOpen(false)}
        anchorEl={anchorElRef.current}
        width="300px"
      />
    </>
  );
};

export default ColorBoxPicker;
